<template>
    <BCard no-body>
        <BCardHeader class="pb-50">
            <h5> {{ $t('Filters') }} </h5>
        </BCardHeader>
        <BCardBody>
            <BRow>
                <vSelectValidated v-if="$existsModule('Academy')" vsName="Profesor/a" :vsModel.sync="teacherFilter" :vsOptions="teachers" vsLabel="full_name" :reduce="val => val.id" @vsOnSearch="onSearchTeacher" vsMd="6" :vsClearable="true"/>
                <vSelectValidated vsName="Curso" :vsModel.sync="courseFilter" :vsOptions="courses" vsLabel="search_name"  :reduce="val => val.id" @vsOnSearch="onSearchCourse" vsMd="6" :vsClearable="true"/>
            </BRow>
        </BCardBody>
    </BCard>
</template>

<script>
import { inject } from '@vue/composition-api';
import { BCard, BCardBody, BCardHeader, BCol, BRow } from 'bootstrap-vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue'

export default {
    components: { BCard, BCardHeader, BCardBody, BRow, BCol, vSelectValidated },
    emits: ['search-teachers', 'search-courses'],
    setup(props, {emit}){
        const teacherFilter = inject('teacherFilter')
        const courseFilter = inject('courseFilter')
        const teachers = inject('teachers')
        const courses = inject('courses')


        const onSearchCourse = (val) => {
            emit('search-courses', val)
        }

        const onSearchTeacher = (val) => {
            emit('search-teachers', val)
        }

        return {
            teacherFilter,
            courseFilter,
            teachers,
            courses,
            onSearchCourse,
            onSearchTeacher
        }
    }
}
</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
</style>